import { phone, email, pdfCommissions, pdfLevels, pdfTraining1 } from '@/config'

const contacts = {
  whatsapp1: '233540950578'
}

const referralLink = 'https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fgh%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.com.gh%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://web.facebook.com/JForceGhana?_rdc=3&_rdr',
    newPage: true
  },
  {
    disabled: true,
    img: 'img/dashboard/comingSoon.svg',
    title: {
      key: 'dashboard.media.jforce_blog'
    },
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
  {
    img: 'img/dashboard/contact-form.svg',
    title: {
      text: 'Get support here'
    },
    link: 'https://docs.google.com/forms/d/1D34TYGBUfbv26gbT3sL8E-k4v8RQ4_pyFrTyeRXbLm0/edit?usp=forms_home&ths=true',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      text: 'Contact us via Whatsapp',
    },
    subtitle: {
      text: '54 095 0578',
      isKey: false
    },
    link: 'https://wa.me/+2330540950578',
    newPage: true
  },
  {
    img: 'img/dashboard/helpline.svg',
    title: {
      text: 'Call us'
    },
    subtitle: {
      text: phone,
      isKey: false
    },
    link: 'tel:' + phone,
    newPage: false
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      text: 'Join us on Facebook'
    },
    link: 'https://web.facebook.com/JForceGhana?_rdc=3&_rdr',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-telegram.svg',
    title: {
      text: 'Join us on Telegram',
    },
    link: 'https://t.me/+Vo7rASZlSu1TbNAu',
    newPage: true
  },
]

const dashboardOtherItems = [
  {
    disabled: false,
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      key: 'dashboard.other.commission_grid'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/medal.svg',
    title: {
      key: 'dashboard.other.levels'
    },
    link: pdfLevels,
    newPage: true
  },
  {
    img: 'img/dashboard/jumia-pickup-station.png',
    title: {
      key: 'dashboard.other.pickup_station'
    },
    link: 'https://www.jumia.com.gh/sp-pickups/',
    newPage: true
  },
  {
    img: 'img/dashboard/training.png',
    title: {
      text: 'Training Manual'
    },
    link: pdfTraining1,
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
